import { Locale } from 'vant';
import enUS from 'vant/lib/locale/lang/en-US';
import 'vant/lib/index.css';

Locale.use('en-US', enUS);
